import { PageHero } from "@/components/PageHero";
import { POLICIES } from "@/lib/data";

const Policies = () => (
  <div data-testid="policies-page">
    <PageHero
      overline="Policies"
      title={
        <>
          Living well,
          <span className="italic text-brand-gold"> together.</span>
        </>
      }
      lead="A small set of agreements that keep Exente warm, fair and welcoming for everyone."
      image="https://images.unsplash.com/photo-1466692476868-aef1dfb1e735?auto=format&fit=crop&w=1600&q=80"
    />

    <section className="py-24 md:py-32 px-6 md:px-10">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6">
        {POLICIES.map((p, i) => (
          <article
            key={p.title}
            data-testid={`policy-card-${i}`}
            className="p-10 rounded-2xl border border-brand-sage bg-brand-ivory hover:border-brand-gold transition-colors"
          >
            <div className="font-display text-xl text-brand-gold mb-3">
              {String(i + 1).padStart(2, "0")}
            </div>
            <h3 className="font-display text-2xl md:text-3xl text-brand-forest">{p.title}</h3>
            <ul className="mt-6 space-y-3">
              {p.points.map((pt, j) => (
                <li
                  key={j}
                  className="flex gap-3 text-brand-mute leading-relaxed text-sm md:text-base"
                >
                  <span className="mt-2 w-1.5 h-1.5 rounded-full bg-brand-leaf shrink-0" />
                  {pt}
                </li>
              ))}
            </ul>
          </article>
        ))}
      </div>
    </section>
  </div>
);

export default Policies;
